import { refs, domReady, dispatchEvent, booleanDataset } from '../modules/utils.js';

class AddToCart extends HTMLElement {
  static get observedAttributes() {
    return ['data-value', 'data-price', 'data-total-price'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-value') {
      const value = parseInt(newValue, 10) || 1;
      if (this.dataset.price) {
        const totalPrice = parseInt(this.dataset.price, 10) * value;
        this.dataset.totalPrice = totalPrice;
      }
      this.refs.value.textContent = value;
      dispatchEvent('addtocart:value', { value });
    }

    if (name === 'data-price') {
      const totalPrice = parseInt(newValue, 10) * parseInt(this.dataset.value, 10);
      this.dataset.totalPrice = totalPrice;
    }

    if (name === 'data-total-price') {
      if (this?.refs?.totalPrice) {
        let price = new Intl.NumberFormat(Shopify.locale, {
          style: 'currency',
          currency: Shopify.currency.active,
          currencyDisplay: 'symbol'
        }).format(parseInt(newValue, 10) / 100);
        if (Shopify.locale === 'it') {
          price = `€${price.replace('€', '')}`;
        }
        this.refs.totalPrice.textContent = price;
      }
    }
  }

  async connectedCallback() {
    if (this.disconnected) return;

    await domReady();
    this.refs = refs(this);
    this.#listeners();
    this.dataset.value = parseInt(this.refs.value.textContent, 10) || 1;
  }

  disconnectedCallback() {
    this.disconnected = true;
  }

  #listeners() {
    document.addEventListener('productvariants:variant', ({ detail }) => {
      if (detail.id) {
        this.dataset.variantId = detail.id;
      }
    });

    document.addEventListener('productvariants:price', ({ detail }) => {
      if (detail.price) {
        this.dataset.price = this.#convertPriceToInteger(detail.price);
      }
    });

    document.addEventListener('addtocart:value', ({ detail }) => {
      if (detail.value !== parseInt(this.dataset.value)) {
        this.dataset.value = detail.value;
      }
    });

    this.refs.add?.addEventListener('click', () => {
      this.dataset.value = parseInt(this.dataset.value, 10) + 1;
    });

    this.refs.subtract?.addEventListener('click', () => {
      const value = parseInt(this.dataset.value, 10);
      if (value > 1) {
        this.dataset.value = value - 1;
      }
    });

    this.refs.addToCart?.addEventListener('click', () => this.#addToCart());
  }

  #convertPriceToInteger(price) {
    if (typeof price === 'string') {
      price = price.replace(/[^0-9.-]+/g, '');
    }
    return parseInt(price, 10);
  }

  async #addToCart() {
    const formData = {
      'items': [{
        'id': parseInt(this.dataset.variantId),
        'quantity': parseInt(this.dataset.value, 10) || 1
      }]
    };

    this.refs.addToCart && booleanDataset(this.refs.addToCart, 'loading', true);

    return fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => response.json())
      .then((data) => {
        if (data?.status === 422) {
          dispatchEvent('addtocart:error', { message: data.description });
        }
        else {
          dispatchEvent('cart:update');
          dispatchEvent('addtocart:added');
        }
        this.refs.addToCart && booleanDataset(this.refs.addToCart, 'loading', false);
      })
      .catch((error) => {
        dispatchEvent('addtocart:error', { message: error.message });
        this.refs.addToCart && booleanDataset(this.refs.addToCart, 'loading', false);
      });
  }
}

customElements.define('add-to-cart', AddToCart);
